import React, { createContext, useContext, useState } from "react";
import { SnackbarAction, SnackbarVariant } from "./Snackbar";

interface SnackbarContextType {
  setMessage: (variant: SnackbarVariant, msg: string, action?: SnackbarAction | null) => void;
  variant: SnackbarVariant;
  message: string;
  action: SnackbarAction | null;
}

const SnackbarContext = createContext<SnackbarContextType>({
  setMessage: () => {},
  variant: "info",
  message: "",
  action: null,
});

export interface SnackbarContextProviderProps {
  children: React.ReactNode;
}

export const SnackbarContextProvider = ({ children }: SnackbarContextProviderProps) => {
  const [variant, setInternalVariant] = useState<SnackbarVariant>("info");
  const [message, setInternalMessage] = useState<string>("");
  const [action, setInternalAction] = useState<SnackbarAction | null>(null);
  const setMessage = (variant: SnackbarVariant, message: string, action: SnackbarAction | null = null) => {
    setInternalVariant(variant);
    setInternalMessage(message);
    setInternalAction(action);
  };
  return <SnackbarContext.Provider value={{ variant, message, action, setMessage }}>{children}</SnackbarContext.Provider>;
};

export const useSnackbar = () => {
  return useContext<SnackbarContextType>(SnackbarContext);
};
